export const C__SearchForm = () => ({
    s: '',
    isOpen: false,
    spinnerStatus: 'idle',

    async search() {
        if (this.s === '') return;

        this.spinnerStatus = await this.setSpinnerStatus('loading'); // show spinner

        window.location.href = `/?s=${this.s}`;
    },

    openSearchForm() {
        this.isOpen = !this.isOpen;

        if (this.isOpen) {
            setTimeout(() => {
                document.getElementById('search-input').focus();
            }, 200);
        }
    },

    async setSpinnerStatus(status) {
        return new Promise(function (resolve, reject) {
            if (status == 'done') {
                setTimeout(() => {
                    status = 'idle';

                    resolve(status);
                }, 800);
            } else {
                resolve(status);
            }
        });
    }
});
